<template>
    <input-text
    @input="v => $emit('input', v)"
    v-bind="$attrs" />
</template>

 
<script>

    import {mapState} from 'vuex'

    export default {

        props: {
            row: {
                type: Object,
                default: () => {}
            }
        }

    }
</script>